import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import { setMomentLocale } from '../utils/moment-locales'

import { SUPPORTED_LOCALES } from '../app/constants'

const updateInterfaceLanguage = (newLocale: string, currentLocale: string) => {
  if (
    newLocale !== currentLocale &&
    SUPPORTED_LOCALES.includes(currentLocale) &&
    SUPPORTED_LOCALES.includes(newLocale)
  ) {
    i18next.changeLanguage(newLocale)
  }
}

export const updateMomentLocale = (locale: string) => {
  if (!SUPPORTED_LOCALES.includes(locale)) {
    return
  }
  
  // Use the utility function to handle locale setting
  setMomentLocale(locale)
}

export const maybeChangeLocale = (newLocale: string, currentLocale: string) => {
  const current = currentLocale?.split('-')[0]
  updateInterfaceLanguage(newLocale, current)
  updateMomentLocale(newLocale)
}

export const useLocale = () => {
  const { i18n, t } = useTranslation('translation')

  return {
    i18n,
    t,
  }
}
